"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TenantIsolationViolation = void 0;
const domain_error_js_1 = require("./domain-error.js");
/**
 * Thrown when a request attempts to access or modify data belonging
 * to a tenant other than the one established by the validated JWT.
 */
class TenantIsolationViolation extends domain_error_js_1.DomainError {
    constructor(message = 'Tenant isolation violation', cause) {
        super(message, 'TENANT_ISOLATION_VIOLATION', cause);
    }
}
exports.TenantIsolationViolation = TenantIsolationViolation;
//# sourceMappingURL=tenant-isolation-violation.js.map